export const SPARK_PRODUCT = 'spark';
export const SLEEPIO_PRODUCT = 'sleepio';

export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please double check your information and try again.';
